/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryFollowupEditDialog extends Common.GridEditorDialog<EnquiryFollowupRow> {
        protected getFormKey() { return EnquiryFollowupForm.formKey; }
        protected getLocalTextPrefix() { return EnquiryFollowupRow.localTextPrefix; }

        protected form: EnquiryFollowupForm;
        public maxMark: number;
        constructor() {
            super();
            //
            this.form = new EnquiryFollowupForm(this.idPrefix);

        }
        loadEntity(entity: EnquiryFollowupRow) {
            super.loadEntity(entity);
            //debugger;
            if ((!Authorization.hasPermission("Administration:Security")) && (Authorization.hasPermission("Users:Manager") || Authorization.hasPermission("Users:SalesExecutive") || Authorization.hasPermission("Users:TechSupport")))
            {
                if (this.isNew()) {
                    this.form.FollowedBy.set_readOnly(false);
                    this.form.FollowedBy.set_value(this.form.FollowedBy.items[0].id);
                }
                else {
                    this.form.FollowedBy.set_readOnly(true);
                }
            }
            else {
                if (this.isNew()) {
                    this.form.FollowedBy.value = "";
                }

            }
        }
    }
}